import { useTranslation } from "react-i18next";
import { useEstimateStructure, SectionTitle } from "@tools";
import { Button } from "@components";
import { Add } from "@material-ui/icons";
import useStyle from "./NewSectionButton.style";

export const NewSectionButton = () => {
  const structure = useEstimateStructure();
  const { t } = useTranslation();
  const classes = useStyle();
  
  const handleNewSection = () => {
    structure.addSection();
  }

  return (
    <SectionTitle spacing>
      <Button
        variant="outlined"
        color="primary"
        className={classes.sectionButton}
        onClick={handleNewSection}
        icon={<Add />}
      >
        {t("views.editor.add_section")}
      </Button>
    </SectionTitle>
  );
};